import { formatUnits } from "@ethersproject/units";
import { BigNumber } from "@ethersproject/bignumber";
import { isEmpty } from "lodash";

export const getTokenPairsList = pairs => {
  if (!isEmpty(pairs)) {
    return pairs.map(pair => {
      return {
        ...pair,
        normalizedUnderlyingTokenPrice: pair.underlyingTokenPrice ? parseFloat(formatUnits(pair.underlyingTokenPrice.toString(), 18)) : null
      };
    });
  }
  return [];
};

export const getPositionTokens = positionTokens => {
  if (positionTokens) {
    return positionTokens.map(positionToken => {
      return {
        ...positionToken,
        address: positionToken.address,
        marketId: positionToken.marketId,
        name: positionToken.name,
        shortName: positionToken.shortName
      };
    });
  }
  return [];
};

export const getLpPositionTokens = lpPositionTokens => {
  if (lpPositionTokens) {
    return lpPositionTokens.map(positionToken => {
      return {
        marketId: positionToken.marketId,
        ...positionToken,
        positionId: positionToken.positionId.toString(),
        name: positionToken.name,
        shortName: positionToken.shortName
      };
    });
  }
  return [];
};

// DECORATORS
export const decorateTokenBalances = token => {
  return {
    ...token,
    walletBalance18Decimals:
      token.decimals && token.walletBalance && token.accountBalance
        ? token.decimals.toString() === "18"
          ? token.walletBalance
          : BigNumber.from(token.walletBalance.toString())
              .mul(BigNumber.from((10 ** (18 - token.decimals)).toString()))
              .toString()
        : null,
    normalizedAccountBalance: token.accountBalance ? parseFloat(formatUnits(token.accountBalance, 18)) : null,
    normalizedAccountBalance2Decimals: token.accountBalance ? Math.floor(formatUnits(token.accountBalance, 18) / 0.01) * 0.01 : null,
    normalizedAccountBalance4Decimals: token.accountBalance ? Math.floor(formatUnits(token.accountBalance, 18) / 0.0001) * 0.0001 : null,
    printableAccountBalance: token.accountBalance
      ? parseFloat(formatUnits(token.accountBalance, 18))
          .toFixed(2)
          .toString()
      : null,
    normalizedWalletBalance: token.walletBalance && token.decimals ? parseFloat(formatUnits(token.walletBalance, token.decimals)) : null,
    normalizedWalletBalance2Decimals:
      token.walletBalance && token.decimals ? Math.floor(formatUnits(token.walletBalance, token.decimals) / 0.01) * 0.01 : null,
    normalizedWalletBalance4Decimals:
      token.walletBalance && token.decimals ? Math.floor(formatUnits(token.walletBalance, token.decimals) / 0.0001) * 0.0001 : null,
    printableWalletBalance:
      token.walletBalance && token.decimals
        ? parseFloat(formatUnits(token.walletBalance, token.decimals))
            .toFixed(2)
            .toString()
        : null
  };
};
